const POLICY_VIEW_TO_PATH = {
  privacy: '/privacy',
  refund: '/refund',
  shipping: '/shipping-and-returns',
  terms: '/terms',
  contact: '/hit-us-up',
  'vibe-check': '/account/vibe-check',
}

const POLICY_HASH_TO_VIEW = {
  '#contact': 'contact',
  '#hit-us-up': 'contact',
  '#privacy': 'privacy',
  '#refund': 'refund',
  '#shipping-and-returns': 'shipping',
  '#terms': 'terms',
  '#terms-of-the-vibe': 'terms',
}

export const POLICY_FOOTER_LINKS = [
  {
    label: 'Privacy',
    view: 'privacy',
  },
  {
    label: 'Refund',
    view: 'refund',
  },
  {
    label: 'Terms',
    view: 'terms',
  },
  {
    label: 'Hit Us Up',
    view: 'contact',
  },
]

export const POLICY_ROUTE_VIEWS = new Set(Object.keys(POLICY_VIEW_TO_PATH))

function normalizePolicyPathname(pathname) {
  const normalizedPathname = String(pathname || '').trim().toLowerCase()

  if (!normalizedPathname) {
    return '/'
  }

  if (normalizedPathname === '/') {
    return '/'
  }

  return normalizedPathname.replace(/\/+$/, '')
}

export function getPolicyPathForView(view) {
  return POLICY_VIEW_TO_PATH[view] ?? ''
}

export function getPolicyViewFromPath(pathname) {
  return (
    Object.entries(POLICY_VIEW_TO_PATH).find(
      ([, routePath]) => routePath === normalizePolicyPathname(pathname),
    )?.[0] ?? null
  )
}

export function getPolicyViewFromHash(hash) {
  return POLICY_HASH_TO_VIEW[String(hash || '').trim().toLowerCase()] ?? null
}

export function getPolicyViewFromLocation(pathname, hash) {
  return getPolicyViewFromPath(pathname) ?? getPolicyViewFromHash(hash)
}
